import { render, staticRenderFns } from "./ToggleSwitch.vue?vue&type=template&id=6ef4ae8e&scoped=true&"
import script from "./ToggleSwitch.vue?vue&type=script&lang=ts&"
export * from "./ToggleSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleSwitch.vue?vue&type=style&index=0&id=6ef4ae8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef4ae8e",
  null
  
)

export default component.exports